"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Iterator_1 = __importDefault(require("../Maker/Iterator"));
const ContainerHolder_1 = __importDefault(require("../../../Container/ContainerHolder"));
const clock_1 = require("@almservices-cl/clock");
const names = [
    { firstName: "Michael", lastName: "Goldner" },
    { firstName: "Debra", lastName: "Kibble" },
    { firstName: "Yoshiko", lastName: "Crowden" },
    { firstName: "Daphne", lastName: "Wattley" },
    { firstName: "Heide", lastName: "Buckle" },
    { firstName: "Cleveland", lastName: "Englert" },
    { firstName: "Rosio", lastName: "Pawloski" },
    { firstName: "Carly", lastName: "Darr" },
    { firstName: "Elbert", lastName: "Leamon" },
    { firstName: "Johnny", lastName: "Bentler" },
    { firstName: "Lorretta", lastName: "Hegna" },
    { firstName: "Verdell", lastName: "Daughtridge" },
    { firstName: "Jasmin", lastName: "Gaspar" },
    { firstName: "Leanne", lastName: "Kupiec" },
    { firstName: "Abbey", lastName: "Blanch" },
    { firstName: "Jean", lastName: "Dear" },
    { firstName: "Refugia", lastName: "Schrader" },
    { firstName: "Jarrett", lastName: "Karn" },
    { firstName: "Zola", lastName: "Stpeter" },
    { firstName: "Alina", lastName: "Averette" },
];
const cityNames = new Iterator_1.default([
    "Amsterdam",
    "Eindhoven",
    "Maastricht",
    "Noordwijk",
    "Rotterdam",
]);
const streetNames = new Iterator_1.default([
    "Bankastraat",
    "Herenstraat",
    "Bloemstraat",
    "Kerkstraat",
    "Oosteinde",
    "Zuideinde",
    "Westeinde",
]);
const months = new Iterator_1.default(["02", "04", "08", "09"]);
const days = new Iterator_1.default(["05", "10", "15", "20", "25"]);
const localeNumber = new Iterator_1.default(["30", "12", "1/7", "89/23"]);
const responseDayIterator = new Iterator_1.default([0, 1, 2, 3, 4, 5, 6]);
const notificationsIterator = new Iterator_1.default([
    true,
    true,
    false,
    true,
    false,
    false,
    true,
]);
const minutesIterator = new Iterator_1.default([
    10, 70, 24, 250, 360, 720, 1200, 25, 47, 72, 99,
]);
const startDaysAgo = new Iterator_1.default([
    15,
    30,
    30 * 2 + 17,
    30 * 5 + 4,
    48,
    7,
    2,
    30 * 4,
]);
const planNamesIterator = new Iterator_1.default([
    "Personal Fat Burning Plan",
    "Personal Muscle Shaping Plan",
    "Personal Fat Ripping Plan",
    "Personal Wedding Plan",
]);
const characterIterator = new Iterator_1.default([
    "T",
    "R",
    "U",
    "C",
    "K",
    "U",
    "Z",
    "F",
    "O",
    "V",
    "B",
]);
const getTrainingCode = () => {
    return [
        characterIterator.next(),
        characterIterator.next(),
        characterIterator.next(),
        characterIterator.next(),
    ].join("-");
};
const trainingPlaceIterator = new Iterator_1.default(["Gym", "Park", "Home"]);
const isNewIterator = new Iterator_1.default([true, false]);
const otherIsNewFlagsIterator = new Iterator_1.default([
    true,
    false,
    true,
    true,
    false,
    false,
    false,
    false,
    true,
    false,
    true,
]);
const methodIterator = new Iterator_1.default([
    "caloriecount",
    "handpalm",
]);
const subscriptionTypeIterator = new Iterator_1.default([
    {
        typeId: "original",
        numberOfCoachingDays: 1,
    },
    {
        typeId: "premium",
        numberOfCoachingDays: null,
    },
    {
        typeId: "plus",
        numberOfCoachingDays: 3,
    },
    {
        typeId: "plus",
        numberOfCoachingDays: 4,
    },
    {
        typeId: "plus",
        numberOfCoachingDays: 5,
    },
]);
const remainingHoursToDateTime = (dateTimeProvider, dateTimeModifier, days) => dateTimeModifier.modifyHours(dateTimeProvider.currentRaw(clock_1.UTCTimeZone.z()).date, days * 24);
// cover all days 0-6
const coachingDays = {
    1: [5],
    2: null,
    3: [1, 3, 5],
    4: [0, 4, 6],
    5: [2, 3, 5],
};
exports.default = () => {
    const dateTimeModifier = ContainerHolder_1.default.getInstance().get("SYSTEM_DATE_TIME_MODIFIER" // TODO: it is only workaround for circulars
    );
    const dateTimeProvider = ContainerHolder_1.default.getInstance().get("SYSTEM_DATE_TIME_PROVIDER" // TODO: it is only workaround for circulars
    );
    cityNames.reset();
    streetNames.reset();
    months.reset();
    days.reset();
    localeNumber.reset();
    minutesIterator.reset();
    startDaysAgo.reset();
    responseDayIterator.reset();
    isNewIterator.reset();
    planNamesIterator.reset();
    notificationsIterator.reset();
    characterIterator.reset();
    trainingPlaceIterator.reset();
    methodIterator.reset();
    subscriptionTypeIterator.reset();
    otherIsNewFlagsIterator.reset();
    let id = 1;
    const currentDate = dateTimeProvider.currentDate();
    const currentDayOfWeek = dateTimeProvider.dayOfWeek(currentDate);
    const customers = names.map(({ firstName, lastName }, index) => {
        const dayOfWeek = responseDayIterator.next();
        const subscriptionType = subscriptionTypeIterator.next();
        let responseDeadline;
        if (currentDayOfWeek > dayOfWeek) {
            responseDeadline = remainingHoursToDateTime(dateTimeProvider, dateTimeModifier, -Math.abs(dayOfWeek - currentDayOfWeek));
        }
        else if (currentDayOfWeek < dayOfWeek) {
            responseDeadline = remainingHoursToDateTime(dateTimeProvider, dateTimeModifier, dayOfWeek - currentDayOfWeek);
        }
        else {
            responseDeadline = dateTimeProvider.currentRaw(clock_1.UTCTimeZone.z()).date;
        }
        const startDate = dateTimeProvider.fromDateTimeToDate(dateTimeModifier.modifyDays(currentDate, -startDaysAgo.next()));
        const currentDayOfSubscription = dateTimeModifier.daysDiff(currentDate, startDate);
        const createPeriods = (i) => {
            const periods = [];
            const subscriptionPeriod = {
                periodId: lastName,
                subscriptionId: lastName,
                day: currentDayOfSubscription,
                week: Math.floor(currentDayOfSubscription / 7),
                coachingDays: subscriptionType.typeId !== "premium"
                    ? coachingDays[subscriptionType.numberOfCoachingDays]
                    : null,
                startDate: startDate,
                endDate: dateTimeModifier.modifyDays(startDate, 6 * 30),
                periodType: subscriptionType,
            };
            // prev period
            if (i % 3 === 1) {
                periods.push({
                    ...subscriptionPeriod,
                    startDate: dateTimeModifier.modifyDays(startDate, -(6 * 30) - 1),
                    endDate: dateTimeModifier.modifyDays(startDate, -1),
                });
            }
            // current period
            periods.push(subscriptionPeriod);
            // next period
            if (i % 3 === 2) {
                periods.push({
                    ...subscriptionPeriod,
                    startDate: dateTimeModifier.modifyDays(startDate, 6 * 30 + 1),
                    endDate: dateTimeModifier.modifyDays(startDate, 12 * 30),
                });
            }
            return {
                currentPeriod: subscriptionPeriod,
                periods,
            };
        };
        const periods = createPeriods(index);
        const isNew = isNewIterator.next();
        const isProlonger = otherIsNewFlagsIterator.next();
        const hasNewCoach = otherIsNewFlagsIterator.next();
        const hasRejoined = otherIsNewFlagsIterator.next();
        const hasStartedNewPeriod = otherIsNewFlagsIterator.next();
        const hasUpgraded = otherIsNewFlagsIterator.next();
        const atLeastOneNewTag = isNew ||
            isProlonger ||
            hasNewCoach ||
            hasRejoined ||
            hasStartedNewPeriod ||
            hasUpgraded;
        return {
            id: (id++).toString(),
            galleryId: `galleryId-${id}`,
            firstName,
            lastName,
            address: {
                street: streetNames.next(),
                city: cityNames.next(),
                localeNumber: localeNumber.next(),
                postalCode: "41-200",
            },
            phoneNumber: `+10 1${id}1 222 33${id}`,
            birthDate: id !== 4
                ? `1990-${months.next()}-${days.next()}`
                : null,
            responseDeadLine: responseDeadline,
            subscriptionPeriod: periods.currentPeriod,
            periods: periods.periods,
            email: `${firstName}.${lastName}@example.com`,
            lastActive: id === 4
                ? dateTimeModifier.modifyMinutes(dateTimeProvider.currentRaw(clock_1.UTCTimeZone.z()).date, -minutesIterator.next())
                : null,
            notifications: {
                hasUnseenMeal: notificationsIterator.next(),
                hasUnreadMessage: notificationsIterator.next(),
                hasUnseenTraining: notificationsIterator.next(),
                hasUnseenRecovery: notificationsIterator.next(),
                hasUnseenBehaviour: notificationsIterator.next(),
                hasUnseenMeasurement: notificationsIterator.next(),
                hasUnseenLife: notificationsIterator.next(),
                hasUnseenMind: notificationsIterator.next(),
            },
            plan: {
                name: planNamesIterator.next(),
            },
            period: {
                dateOfPeriodStart: periods.periods[0].startDate,
                dateOfPeriodEnd: periods.periods[periods.periods.length - 1].endDate,
                length: periods.periods.length * 6,
            },
            trainingLocation: {
                placeName: trainingPlaceIterator.next(),
                gymName: "",
            },
            method: methodIterator.next(),
            isIntakeDone: true,
            isNew,
            isProlonger,
            hasNewCoach,
            hasRejoined,
            hasStartedNewPeriod,
            atLeastOneNewTag,
            hasUpgraded,
            hasUpgradedToCoaching: true,
            code: {
                label: "Label Value",
                trainingCode: getTrainingCode(),
                isIndividualCode: isNewIterator.current(),
            },
            absoluteDay: 31,
        };
    });
    customers.push({
        id: "0",
        galleryId: "galleryId-0",
        firstName: "Empty",
        lastName: "Chat",
        address: {
            city: "Moon",
            street: "Apollo",
            localeNumber: "11",
            postalCode: "41-200",
        },
        phoneNumber: `+10 000 000 000`,
        birthDate: `1930-01-20`,
        responseDeadLine: dateTimeModifier.modifyDays(dateTimeProvider.currentRaw(clock_1.UTCTimeZone.z()).date, 1),
        subscriptionPeriod: {
            periodId: "foo",
            day: 1,
            week: 1,
            coachingDays: [0],
            startDate: "2019-01-01",
            endDate: "2019-07-01",
            periodType: {
                typeId: "premium",
                numberOfCoachingDays: 1,
            },
            subscriptionId: "abc-def",
        },
        periods: [
            {
                periodId: "foo",
                subscriptionId: "abc-def",
                day: 1,
                week: 1,
                coachingDays: [3],
                startDate: "2019-01-01",
                endDate: "2019-07-01",
                periodType: {
                    typeId: "premium",
                    numberOfCoachingDays: 1,
                },
            },
        ],
        email: `buzz.aldrin@example.com`,
        lastActive: "2019-08-01T12:35:00+00:00",
        isIntakeDone: true,
        notifications: {
            hasUnseenMeal: true,
            hasUnreadMessage: true,
            hasUnseenTraining: true,
            hasUnseenRecovery: true,
            hasUnseenBehaviour: true,
            hasUnseenMeasurement: true,
            hasUnseenLife: true,
            hasUnseenMind: true,
        },
        period: {
            dateOfPeriodStart: "2019-01-01",
            dateOfPeriodEnd: "2019-07-01",
            length: 6,
        },
        plan: {
            name: "Personal Development Plan",
        },
        trainingLocation: {
            placeName: "Moon",
            gymName: "",
        },
        code: {
            label: "Label Value",
            trainingCode: "N-A-S-A",
            isIndividualCode: true,
        },
        method: "caloriecount",
        isNew: false,
        isProlonger: true,
        hasNewCoach: true,
        hasRejoined: true,
        atLeastOneNewTag: true,
        hasUpgraded: true,
        hasUpgradedToCoaching: true,
        absoluteDay: 160,
    });
    customers.push({
        id: "321",
        galleryId: "galleryId-321",
        firstName: "John",
        lastName: "Subscription",
        address: {
            city: "Moon",
            street: "Apollo",
            localeNumber: "11",
            postalCode: "41-200",
        },
        phoneNumber: `+10 000 000 000`,
        birthDate: `1930-01-20`,
        responseDeadLine: dateTimeModifier.modifyDays(dateTimeProvider.currentRaw(clock_1.UTCTimeZone.z()).date, 1),
        subscriptionPeriod: {
            periodId: "120938",
            subscriptionId: "42d794903c49ae6ebf1a8f5cf6a89af4",
            day: 82,
            week: 12,
            startDate: "2019-12-30",
            endDate: "2020-06-28",
            periodType: {
                typeId: "plus",
                numberOfCoachingDays: 1,
            },
            coachingDays: [2, 3, 4],
        },
        periods: [
            {
                periodId: "120938",
                subscriptionId: "42d794903c49ae6ebf1a8f5cf6a89af4",
                day: 82,
                week: 12,
                startDate: "2019-12-30",
                endDate: "2020-06-28",
                periodType: {
                    typeId: "plus",
                    numberOfCoachingDays: 3,
                },
                coachingDays: [2, 3, 4],
            },
        ],
        email: `johnSubscription@test.com`,
        lastActive: "2019-08-01T12:35:00+00:00",
        isIntakeDone: true,
        notifications: {
            hasUnseenMeal: true,
            hasUnreadMessage: true,
            hasUnseenTraining: true,
            hasUnseenRecovery: true,
            hasUnseenBehaviour: true,
            hasUnseenMeasurement: true,
            hasUnseenLife: true,
            hasUnseenMind: true,
        },
        period: {
            dateOfPeriodStart: "2019-01-01",
            dateOfPeriodEnd: "2019-07-01",
            length: 6,
        },
        plan: {
            name: "Personal Development Plan",
        },
        trainingLocation: {
            placeName: "Moon",
            gymName: "",
        },
        code: {
            label: "Label Value",
            trainingCode: "N-A-S-A",
            isIndividualCode: true,
        },
        method: "caloriecount",
        isNew: false,
        isProlonger: true,
        hasNewCoach: true,
        hasRejoined: true,
        atLeastOneNewTag: true,
        hasUpgraded: false,
        hasUpgradedToCoaching: true,
        absoluteDay: 184,
    });
    return customers;
};
//# sourceMappingURL=customers.js.map